"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaArchives = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const CardName_1 = require("../../CardName");
const Resources_1 = require("../../Resources");
const CardRenderer_1 = require("../render/CardRenderer");
const AutomaHandler_1 = require("../../automa/AutomaHandler");
class MediaArchives extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.MEDIA_ARCHIVES,
            tags: [Tags_1.Tags.EARTH],
            cost: 8,
            metadata: {
                cardNumber: '107',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(1).slash().event().played.any;
                }),
                description: 'Gain 1 M€ for each event EVER PLAYED by all players.',
            },
        });
    }
    play(player) {
        const game = player.game;
        let allPlayedEvents = game.getPlayers().map((player) => player.getPlayedEventsCount()).reduce((a, c) => a + c, 0);
        if (game.isSoloMode() && game.gameOptions.automaSoloVariant) {
            allPlayedEvents += AutomaHandler_1.AutomaHandler.getBotTagCount(game);
        }
        player.addResource(Resources_1.Resources.MEGACREDITS, allPlayedEvents, { log: true });
        return undefined;
    }
}
exports.MediaArchives = MediaArchives;
//# sourceMappingURL=MediaArchives.js.map